import { mods, theme } from '@approvalmax/theme';
import { StyledMods } from '@styled-kit/mods';
import styled, { css } from 'styled-components';

import { ToolbarProps } from './Toolbar.types';

export const Root = styled.div<
    StyledMods<Pick<ToolbarProps, 'spacingTop' | 'spacingBottom' | 'fullWidth' | 'bordered'>>
>`
    background-color: ${theme.color.white100};
    padding: 12px ${theme.container.spacing.large};
    position: sticky;
    top: 0;
    left: 0;
    margin-bottom: -16px;
    z-index: 2;

    ${mods('spacingTop')(
        (value) => css`
            padding-top: ${value}px;
        `
    )};

    ${mods('spacingBottom')(
        (value) => css`
            padding-bottom: ${value}px;

            ${value === 0 && 'margin-bottom: 0;'};
        `
    )};

    ${mods('fullWidth')`
        padding-left: 0;
        padding-right: 0;
    `};

    ${mods.bordered.true`
        box-shadow: inset 0 -1px 0 0 ${theme.color.midnight50};
    `};
`;
